export default class NewsList {
	constructor(config) {
		this.el = config.el;
		this.selectors = {
			pageCount: "#pagecount",
			screenReaderInstructions: "#screenReaderInstructions",
			applyButton: "#applyButton"
		};

		this.pageCount = this.el.querySelector(this.selectors.pageCount);
		this.screenReaderInstructions = this.el.querySelector(this.selectors.screenReaderInstructions);
		this.applyButton = this.el.querySelector(this.selectors.applyButton);

		this.init();
	}
	init() {
		this.attachEvents();
	}
	attachEvents() {

		if (!this.pageCount || !this.screenReaderInstructions || !this.applyButton) {
			return;
		}

		this.pageCount.addEventListener("change", () => {
			this.screenReaderInstructions.innerText = "Ændringer træder først i kraft, når du trykker på knappen 'Anvend'.";
			this.applyButton.focus();
		});
		
	}
}
